import {BasicModalProps} from "../../../../pages/master/interfaces/BasicModalProps";
import {Modal} from "react-bootstrap";
import SecondaryButton from "../../../../pages/master/atom/buttons/SecondaryButton";
import PrimaryButton from "../../../../pages/master/atom/buttons/PrimaryButton";
import {useEffect} from "react";
import client from "../../../../axios";

interface SelectChoiceModalProps extends BasicModalProps {
  selected: string;
  setSelected: (value: string) => void;
  setOpenListModal: (openListModal: boolean) => void;
  setOpenGraphModal: (openGraphModal: boolean) => void;
  selectedRow: Record<string, unknown> | null;
  setDetailData: (detailData: any[]) => void;
}

export default function SelectChoiceModal(props: SelectChoiceModalProps) {

  function handleOpenMoreModal() {
    props.setShow(false);
    setTimeout(() => {
      if (props.selected === 'list') {
        props.setOpenListModal(true);
      } else {
        props.setOpenGraphModal(true);
      }
    }, 200);
  }

  useEffect(() => {
    if (props.show && props.selectedRow) {
      client.get('/api/temperature/detail', { params: { id: props.selectedRow.id }})
        .then((res) => props.setDetailData(res.data));
    }
  }, [props.show, props.selectedRow]);

  return (
    <Modal show={props.show} centered>
      <Modal.Body>
        <div className='form-check'>
          <input
            id='list'
            className='form-check-input'
            type="radio"
            name="myRadio"
            value="list"
            checked={props.selected === "list"}
            onChange={e => props.setSelected(e.target.value)}
          />
          <label htmlFor='list' className='form-check-label'>리스트</label>
        </div>

        <div className='form-check'>
          <input
            id='graph'
            className='form-check-input'
            type="radio"
            name="myRadio"
            value="graph"
            checked={props.selected === "graph"}
            onChange={e => props.setSelected(e.target.value)}
          />
          <label htmlFor='graph' className='form-check-label'>그래프</label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SecondaryButton onClick={() => props.setShow(false)}>
          닫기
        </SecondaryButton>
        <PrimaryButton onClick={handleOpenMoreModal}>
          열기
        </PrimaryButton>
      </Modal.Footer>
    </Modal>
  )
}